<template>
  <div id="app">
    <Header></Header>
    <!-- <transition enter-active-class="wow animated slideInLeft"
    leave-active-class="wow animated slideOutRight"> -->
    <router-view />
    <div class="tool-bar" :class="isShowToolBar ? 'show-bar' : ''">
      <div class="tool-wrap">
        <div class="showarea">
          <div class="phone" :class="isShowConnet ? 'show-item' : ''">
            <div class="phone-img">
              <img src="./assets/img/icon/icon_dh2@2x.png" alt="" />
            </div>
            <div class="phone-number">
              <div>24小时服务热线</div>
              <div>{{ about_us1.phone }}</div>
            </div>
          </div>
          <div class="QR" :class="isShowQR ? 'show-item' : ''">
            <div class="QR-img">
              <img :src="about_us1.img == undefined ?'':domain + about_us1.img" alt="" />
            </div>
            <div class="QR-number">关注我们</div>
          </div>
        </div>
        <div class="bar">
          <div class="bar-item" @click="toTop()">
            <img class="top" src="./assets/img/icon/icon_TOP@2x.png" alt="" />
            <span>TOP</span>
          </div>
          <div class="line"></div>
          <div
            class="bar-item"
            @mouseover="isShowConnet = true"
            @mouseleave="isShowConnet = false"
          >
            <img src="./assets/img/icon/icon_kfrx@2x.png" alt="" />
            <span>客服热线</span>
          </div>
          <div class="line"></div>
          <div
            class="bar-item"
            @mouseover="isShowQR = true"
            @mouseleave="isShowQR = false"
          >
            <img src="./assets/img/icon/icon_wxgzh@2x.png" alt="" />
            <span>微信公众号</span>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->
  </div>
</template>
<script>
import Header from "./components/header.vue";
import { BASEDOMAIN } from "./common/config";
import { aboutUs } from "./network/http_api";

export default {
  data() {
    return {
      isShowToolBar: false,
      isShowConnet: false,
      about_us1: "",
      isShowQR: false,
      domain: "",
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.domain = BASEDOMAIN;
    this.getlinkData();
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("keydown", function (e) {
      if (e.key == "F12") {
        e.preventDefault(); // 如果按下键F12,阻止事件
      }
    });
    document.oncontextmenu = new Function("event.returnValue=false");
  },
  methods: {
    async getlinkData() {
      let res = await aboutUs();
      if (res.code == 200) {
        // let enterprise_profile = JSON.parse(res.data.enterprise_profile);
        // let development_history = JSON.parse(res.data.development_history);
        // let enterprise_honor = JSON.parse(res.data.enterprise_honor);
        // let certificate_honor = JSON.parse(res.data.certificate_honor);
        // let corporate_witness = JSON.parse(res.data.corporate_witness);
        // let partner = JSON.parse(res.data.partner);
        this.about_us1 = JSON.parse(res.data.about_us);
        //console.log('about_us',this.about_us1);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("aboutUs", res);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 600) {
        this.isShowToolBar = true;
      } else {
        this.isShowToolBar = false;
      }
    },
    toTop() {
      let top = document.documentElement.scrollTop;
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 8);
    },
  },
};
</script>
<style lang="less">
@import "./assets/css/normalize.css";
// @import "./assets/iconfont/iconfont.css";
#app {
  font-size: 16px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

img {
  -webkit-user-drag: none; // 防止图片在Chrome和Safari中被拖动
  -webkit-user-select: none; // 防止图片在Chrome和Safari中被选择（例如，用鼠标单击）
  -moz-user-select: none; // 防止图片在Firefox中被选择（例如，用鼠标单击）
  user-select: none; // 防止图片在其他浏览器中被选择（例如，用鼠标单击）
}

.tool-bar {
  position: fixed;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: none;
  z-index: 999;
  opacity: 0;
  transition: all 2s linear 2s;
  .tool-wrap {
    position: relative;
  }
  .showarea {
    .phone {
      position: absolute;
      left: -215px;
      display: flex;
      padding: 35px 25px;
      background: #fff;
      margin: 50px 5px 0 0;
      opacity: 0;
      transition: all 0.5s;
      .phone-img {
        width: 50px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      .phone-number {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        color: #999;
      }
    }
    .QR {
      position: absolute;
      left: -137px;
      opacity: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 13px 25px;
      background: #fff;
      margin: 50px 5px 0 0;
      .QR-img {
        width: 72px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      .QR-number {
        font-size: 14px;
        color: #999;
      }
    }
    .show-item {
      opacity: 1;
      transition: all 0.5s;
    }
  }
  .bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 10px 12px 20px 12px;

    .line {
      height: 1px;
      width: 30px;
      margin: 10px 0;
      background: #d9d9d9;
    }
    .bar-item {
      display: flex;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      img {
        width: 32px;
      }
      .top {
        width: 22px;
      }
      span {
        font-size: 12px;
        color: #606266;
        margin-top: 5px;
      }
    }
  }
}
.show-bar {
  display: flex;
  opacity: 1;
  transition: all 2s linear 2s;
}
</style>
